import * as types from './_actionTypes';

const initialState = {
  results: {
    quizzes: [],
    assessments: [],
    exam: null,
    overall: null
  },
  certificates: [],
  loading: false,
  downloading: {},
  error: null
};

const studentResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STUDENT_RESULTS_REQUEST:
    case types.FETCH_CERTIFICATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_STUDENT_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
        error: null
      };
    
    case types.FETCH_CERTIFICATES_SUCCESS:
      return {
        ...state,
        loading: false,
        certificates: action.payload,
        error: null
      };
    
    case types.FETCH_STUDENT_RESULTS_FAILURE:
    case types.FETCH_CERTIFICATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.DOWNLOAD_CERTIFICATE_REQUEST:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.payload]: true
        }
      };
    
    case types.DOWNLOAD_CERTIFICATE_SUCCESS:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.meta?.certificateId]: false
        }
      };
    
    case types.DOWNLOAD_CERTIFICATE_FAILURE:
      return {
        ...state,
        downloading: {
          ...state.downloading,
          [action.meta?.certificateId]: false
        },
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default studentResultsReducer;